const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000'

export interface Notification {
  id: string
  type: string
  title: string
  message: string
  reference_id: string
  read: boolean
  created_at: string
}

export interface GetNotificationsResponse {
  notifications: Notification[]
  total: number
  unreadCount: number
  limit: number
  offset: number
}

export interface GetUnreadCountResponse {
  unreadCount: number
}

async function getAuthHeaders(): Promise<Record<string, string>> {
  const token = localStorage.getItem('access_token')
  return {
    'Authorization': `Bearer ${token}`
  }
}

export const notificationService = {
  /**
   * Get notifications with pagination
   */
  async getNotifications(
    limit = 20,
    offset = 0,
    unreadOnly = false
  ): Promise<GetNotificationsResponse> {
    const headers = await getAuthHeaders()
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString()
    })
    if (unreadOnly) {
      params.set('unread', 'true')
    }

    const response = await fetch(
      `${API_URL}/notifications?${params}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...headers
        }
      }
    )

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Erro ao buscar notificacoes')
    }

    return response.json()
  },

  /**
   * Get unread count only
   */
  async getUnreadCount(): Promise<GetUnreadCountResponse> {
    const headers = await getAuthHeaders()
    const response = await fetch(
      `${API_URL}/notifications/unread-count`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...headers
        }
      }
    )

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Erro ao buscar contagem')
    }

    return response.json()
  },

  /**
   * Mark a notification as read
   */
  async markAsRead(id: string): Promise<{ notification: Notification }> {
    const headers = await getAuthHeaders()
    const response = await fetch(
      `${API_URL}/notifications/${id}/read`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...headers
        }
      }
    )

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Erro ao marcar como lida')
    }

    return response.json()
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<{ count: number }> {
    const headers = await getAuthHeaders()
    const response = await fetch(
      `${API_URL}/notifications/read-all`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...headers
        }
      }
    )

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Erro ao marcar todas como lidas')
    }

    return response.json()
  }
}

export default notificationService
